import { useAppDispatch } from "../../../state/store";
import { selectCareRecipientAction } from "../../../state/usecase/care_recipient/actions";
import { useCareRecipientList } from "./useCareRecipientList";
import { useEffect, useState } from "react";
import { CareRecipient } from "../../../domain/care_recipient/CareRecipient";
import { useCareRecipientIdFromPath } from "./useCareRecipientIdFromPath";

// パス変数に利用者IDが含まれている場合に、利用者IDに紐づく利用者名をRedux-Storeに設定します
// イベントハンドラによるページ遷移をせず、ページリロードなどを行った時にヘッダーの利用者名が未選択になることを防いでいます.
export function useSelectCareRecipientFromPath() {

    const dispatch = useAppDispatch();
    const careRecipientId = useCareRecipientIdFromPath();
    const { careRecipients } = useCareRecipientList();
    const [careRecipientFromPath, setCareRecipientFromPath] = useState<CareRecipient>();

    if (!careRecipientId) return;

    useEffect(() => {
        const targetCareRecipient = careRecipients.find(careRecipient => careRecipient.id.value === careRecipientId.value);
        setCareRecipientFromPath(targetCareRecipient);
    }, [careRecipientId, careRecipients, dispatch]);

    useEffect(() => {
        if (!careRecipientFromPath) return;
        dispatch(selectCareRecipientAction({ id: careRecipientFromPath.id, name: careRecipientFromPath.name, houseId: careRecipientFromPath.houseId, customerCode: careRecipientFromPath.customerCode, branchCode: careRecipientFromPath.branchCode }));
    }, [dispatch, careRecipientFromPath]);
}
